import {post} from "../modules/ajax";
import Splide from "@splidejs/splide";
import Swiper from "swiper-v11";
import {Navigation} from 'swiper-v11/modules';
import {hoverElementEvent} from "../modules/events";
import {isDesktop} from "../modules/devices";
import {getLastViewedProducts} from "../modules/last-viewed-products";
import {adjustArrows} from "./recommenders";
import {isPremiumUser} from "./user";
import {
    calculateCustomSizePrice,
    calculatePrice, convertSvgToBase64, fixPersonalizedSVG,
    getSizesPrices,
    getSvgPreviewImage,
    sendEventsAddToCart,
    trackProductPageGa4Events
} from "./product";
import {formatPrice} from "./price";
import {fadeIn, fadeOut, hideElement, showElement, slideDown, slideUp} from "./element-visibility";
import {addItem, addItems, openCart, updateItemsNumber} from "./cart";
import {hideOffcanvasByDomObject, showOffcanvasByDomObject} from "./offcanvas";
import {ga4TrackSimpleEvent} from "../modules/analytics";

let imageSliders = [];

export function updateList(type, filters, query, url, imageDisplay)
{
    return new Promise(resolve => {
        post(
            '/ajax/website/product-list/update',
            {
                type: type,
                filters: filters,
                q: query,
                url: url,
                imageDisplay: imageDisplay
            },
            function (data) {
                resolve(data);
            },
            function (error) {
                resolve([]);
            }
        );
    });
}

export function openFiltersSections(filters)
{
    filters.forEach(function(filter) {
        let section = filter.closest('section');
        let collapse = section.querySelector('.body.collapse');
        if (!collapse) return;
        collapse = Collapse.getOrCreateInstance(section.querySelector('.body.collapse'));
        collapse.show();
    });
}

export function openFiltersChild(filters)
{
    filters.forEach(function(filter) {
        let container = filter.closest('.filters-list');
        let isParent = filter.classList.contains('parent');
        let isChild = filter.classList.contains('child');

        if (isParent) {
            let child = container.querySelector(`input[name="filter"][data-parent="${filter.value}"]`);
            if (!child) return;
            let collapse = Collapse.getOrCreateInstance(child.closest('.child-categories'));
            collapse.show();
        } else if (isChild) {
            let collapse = Collapse.getOrCreateInstance(filter.closest('.child-categories'));
            collapse.show();
        }
    });
}

export function initCombinationSuggestions(combinationSuggestions)
{
    if (combinationSuggestions) {
        let type = 'loop';
        if (combinationSuggestions.querySelectorAll('.combination-suggestion').length === 1) type = 'slide';
        new Splide(combinationSuggestions, {
            type: type,
            perPage: 1,
            perMove: 1,
            padding: '5rem',
            lazyLoad: 'nearby',
            gap: 12,
            mediaQuery: 'min',
            breakpoints: {
                768: {
                    type: 'slide',
                    pagination: false,
                    perPage: 5,
                    perMove: 5,
                    padding: 0,
                }
            }
        }).mount();
    }
}

export function updateImageDisplay(type)
{
    let productsImages = document.querySelectorAll('.product-images');
    productsImages.forEach((productImages) => productImages.dataset.type = type);
}

export function displayProductProductListImages(container, speed = 300)
{
    let sliders = container.querySelectorAll('.swiper');
    //sliders.forEach((slider) => slider.swiper.slideTo(slider.swiper.slides.length - 1, speed));
    sliders.forEach((slider) => productListImagesMoveToSlideFade(slider.swiper, slider.swiper.slides.length - 1, speed));
}

export function displayRoomProductListImages(container, speed = 300)
{
    let sliders = container.querySelectorAll('.swiper');
    //sliders.forEach((slider) => slider.swiper.slideTo(0, speed));
    sliders.forEach((slider) => productListImagesMoveToSlideFade(slider.swiper, 0, speed));
}

let switchProductListImageTimers = {};
function productListImagesMoveToSlideFade(slider, position, speed = 100)
{
    let slideIndex = getSlideIndex(slider, position);
    let id = "id" + Math.random().toString(16).slice(2); //slider.el.id;
    let images = slider.el.querySelectorAll('picture');
    images.forEach((image) => image.classList.add('transitioning'));
    slider.slideTo(slideIndex, 0);
    clearTimeout(switchProductListImageTimers[id]);
    switchProductListImageTimers[id] = setTimeout(function() {
        images.forEach((image) => image.classList.remove('transitioning'));
    }, speed);
}

export function getFilters(container)
{
    let filters = {};

    container.querySelectorAll('input[name="filter"]:checked').forEach(function(filter) {
        let value = filter.value;
        if (value === '') return;
        let type = filter.dataset.type;

        if (type === 'newProducts') {
            filters[type] = value;
        } else {
            if (!filters.hasOwnProperty(type)) filters[type] = [];
            if (!filters[type].includes(value)) filters[type].push(value);
        }
    });

    return filters;
}

export function initProductImageSliders(container, imageDisplay)
{
    container.querySelectorAll('.product .swiper').forEach(function (slider) {
        let productImageDisplay = slider.dataset.imageDisplay;
        if (!productImageDisplay) productImageDisplay = imageDisplay;
        let swiper = new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 1,
            initialSlide: productImageDisplay === 'product' ? slider.querySelectorAll('.swiper-slide').length - 1 : 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            loop: slider.querySelectorAll('.swiper-slide').length > 1,
            init: false
        });

        swiper.on('beforeInit', function () {
            slider.querySelectorAll('.swiper-slide').forEach((arrow) => arrow.classList.remove('d-none'));
            if (productImageDisplay === 'product') swiper.slideTo(swiper.slides.length - 1);
        });

        swiper.on('afterInit', function () {
            slider.querySelectorAll('.swiper-arrow').forEach((arrow) => arrow.classList.remove('d-none'));
        });

        swiper.init();
    });
}

export function updateExclusivePremiumProducts(container)
{
    let products = container.querySelectorAll('.product.exclusive-premium-product');
    let isPremium = isPremiumUser();

    if (!products || isPremium) return;

    products.forEach(function(product) {
        product.querySelector('.button-add-to-cart').classList.add('d-none');
        product.querySelector('.btn-premium-subscribe').classList.remove('d-none');
    });
}

function getSlideIndex(slider, position)
{
    let slides = slider.slides;
    let index = position;

    slides.forEach(function(slide, key) {
        if (parseInt(slide.dataset.swiperSlideIndex) === position) index = key;
    });

    return index;
}

export function getProductConfigurationViews(productId, productReference)
{
    return new Promise(resolve => {
        post(
            '/ajax/website/product-list/get-product-configuration-views',
            {productId: productId},
            function (data) {
                ga4TrackSimpleEvent({
                    event: 'quick_purchase',
                    method: 'open',
                    content_type: productReference || ''
                });
                resolve([data.mainView, data.views]);
            },
            function (error) {
                ga4TrackSimpleEvent({
                    event: 'quick_purchase',
                    method: 'error',
                    content_type: productReference || ''
                });
                resolve([]);
            }
        );
    });
}

export async function updatePriceElements(currentConfiguration)
{
    let priceContainers = isDesktop() ? currentConfiguration.closest('.product').querySelectorAll('.product-configuration .product-configuration-information .price-container') : document.querySelectorAll('#product-list-page .offcanvas.product-configuration .product-configuration-information .price-container');
    let mainContainer = isDesktop() ? currentConfiguration.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let inputSizes = mainContainer.querySelector('input[name="option-size"]');
    let sizes = inputSizes && inputSizes.value !== '' ? JSON.parse(inputSizes.value) : [];
    let quantity = sizes.length === 1 ? parseInt(sizes[0].quantity) : 1;

   showLoaderPriceElements(currentConfiguration);
    let [price] = await calculatePrice(mainContainer, quantity, getOptions(mainContainer), mainContainer.dataset.productId);

    if (!price) {
        priceContainers.forEach(function(priceContainer) {
            let priceText = priceContainer.querySelector('.price-text');
            let mainPrice = priceContainer.closest('.product-configuration-main');

            if (mainPrice) {
                let priceValue = priceText.querySelector('.price-value');
                let oldPrice = priceText.closest('.product-configuration').querySelector('.old-price');
                priceText.closest('.price').querySelector('.price-of').classList.remove('d-none');
                priceValue.innerHTML = priceValue.dataset.defaultPrice;
                if (oldPrice) oldPrice.classList.remove('d-none');
                if (oldPrice && !oldPrice.classList.contains('text-danger')) priceText.classList.add('text-danger');

            } else {
                priceText.innerHTML = '';
            }

            hideElement(priceContainer.querySelector('.loader'));
            if (mainPrice) showElement(priceContainer.querySelector('.price'));
        });
    } else {
        priceContainers.forEach(function(priceContainer) {
            let priceText = priceContainer.querySelector('.price-text');
            let mainPrice = priceContainer.closest('.product-configuration-main');
            price = formatPrice(price);

            if (mainPrice) {
                let priceOf = priceText.closest('.price').querySelector('.price-of');
                let oldPrice = priceText.closest('.product-configuration').querySelector('.old-price');

                if (!priceOf.classList.contains('d-none')) priceOf.classList.add('d-none');
                if (oldPrice && !oldPrice.classList.contains('d-none')) oldPrice.classList.add('d-none')
                priceText.querySelector('.price-value').innerHTML = price;
                priceText.classList.remove('text-danger');
            } else {
                priceText.innerHTML = price;
            }

            hideElement(priceContainer.querySelector('.loader'));
            showElement(priceContainer.querySelector('.price'));
        });
    }
}

export function showLoaderPriceElements(currentConfiguration)
{
    let priceContainers = isDesktop() ? currentConfiguration.closest('.product').querySelectorAll('.product-configuration .product-configuration-information .price-container') : document.querySelectorAll('#product-list-page .offcanvas.product-configuration .product-configuration-information .price-container');
    priceContainers.forEach(function(priceContainer) {
        hideElement(priceContainer.querySelector('.price'));
        showElement(priceContainer.querySelector('.loader'));
    });
}

export function getOptions(container)
{
    let options = {};

    container.querySelectorAll('input.option-value').forEach(function(option) {
        let optionName = option.dataset.optionName;

        if (optionName === 'size') {
            let sizes = option.value !== '' ? JSON.parse(option.value) : [];
            if (sizes.length === 0) return;
            if (sizes.length === 1) options = {...options, ...sizes[0]};
            else options['sizes'] = sizes;
        } else if (optionName === 'customizer') {
            if (option.value === '') return;
            options = {...options, ...JSON.parse(option.value)};
        } else if (optionName === 'vinyl-rug-format') {
            options['format'] = option.value;
        } else {
            options[optionName] = option.value;
        }
    });

    if (options.hasOwnProperty('quantity')) delete options['quantity'];

    return options;
}

function getComplements(container)
{
    let complements = [];

    let complementsData = container.querySelector('input[name="complements"]').value;
    complementsData = complementsData !== '' ? JSON.parse(complementsData) : [];

    complementsData.forEach(function(complement) {
        complements.push(
            {
                id: complement.id,
                price: complement.price,
                quantity: complement.quantity,
                isLocked: complement.isLocked,
                linkToParent: complement.linkToParent,
                options: {
                    width: complement.width,
                    height: complement.height,
                    device: complement.device,
                    composition: complement.composition
                }
            }
        );
    });

    return complements;
}

export function updateConfigurationStepPoints()
{
    document.querySelectorAll('#product-list-page .product-configuration:not(.product-configuration-main)').forEach(function(container) {
        container.querySelectorAll('.product-configuration-step-point').forEach(function(stepPoint) {
            let configuration = document.querySelector(`.product-configuration[data-configuration-number="${stepPoint.dataset.number}"]`);
            let configurationCompleted = configuration.dataset.completed === 'true';

            if (configurationCompleted) {
                stepPoint.classList.remove('bg-button-info', 'bg-secondary');
                stepPoint.classList.add('bg-green');
            } else if (container.dataset.configurationNumber === stepPoint.dataset.number) {
                stepPoint.classList.remove('bg-secondary', 'bg-green');
                stepPoint.classList.add('bg-button-info');
            } else {
                stepPoint.classList.remove('bg-button-info', 'bg-green');
                stepPoint.classList.add('bg-secondary');
            }
        });
    });
}

export function updateConfigurationButtons()
{
    document.querySelectorAll('#product-list-page .product-configuration:not(.product-configuration-main)').forEach(function(configuration) {
        let isCompleted = configuration.dataset.completed === 'true';
        let footer = configuration.querySelector('.footer');
        let continueConfigurationButton = configuration.querySelector('.continue-configuration');
        let addToCartButton = configuration.querySelector('.btn-add-to-cart');
        let configurationsRemaining = document.querySelectorAll('#product-list-page .product-configuration[data-completed="false"]:not(.product-configuration-main)').length;
        let mainContainer = isDesktop() ? configuration.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
        let mainContainerAddToCartButton = mainContainer.querySelector('.btn-add-to-cart');

        if (isCompleted) {
            if (configurationsRemaining) {
                hideElement(addToCartButton);
                hideElement(mainContainerAddToCartButton);
                showElement(continueConfigurationButton);
            } else {
                hideElement(continueConfigurationButton);
                showElement(addToCartButton);
                showElement(mainContainerAddToCartButton);
            }
            slideDown(footer);
        } else {
            hideElement(continueConfigurationButton);
            hideElement(addToCartButton);
            hideElement(mainContainerAddToCartButton);
            slideUp(footer);
        }
    });
}

export async function updateSizesPrices(currentConfiguration)
{
    let mainContainer = isDesktop() ? currentConfiguration.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let productId = mainContainer.dataset.productId;
    let sizesContainer = isDesktop() ? currentConfiguration.closest('.product').querySelector('.product-configuration-size') : document.querySelector('#product-list-page .offcanvas.product-configuration-size');
    let options = getOptions(mainContainer);
    let prices = await getSizesPrices(mainContainer, options);

    prices.forEach(function (element) {
        let id = element.id;
        let price = element.price;
        let oldPrice = element.oldPrice;
        let quantitiesDiscount = element.quantitiesDiscount;
        let input = sizesContainer.querySelector(`input[name="size"][data-id="${id}"]`);
        let quantitySelector = input.nextElementSibling.querySelector('.quantity-selector');
        let priceElement = sizesContainer.querySelector(`label[for="${input.id}"] .size-price`);
        let oldPriceElement = sizesContainer.querySelector(`label[for="${input.id}"] .size-old-price`);

        if (priceElement) priceElement.innerHTML = price;
        if (oldPriceElement) oldPriceElement.innerHTML = oldPrice;
        if (quantitySelector && quantitiesDiscount) {
            quantitiesDiscount.forEach(function (quantityDiscount) {
                let quantity = quantityDiscount.quantity;
                let text = quantityDiscount.text;
                let price = quantityDiscount.price;
                let tomselectOption = quantitySelector.tomselect.getOption(quantity);
                let option = quantitySelector.querySelector(`option[value="${quantity}"]`);

                if (tomselectOption) tomselectOption.querySelector('.item-price').innerHTML = text;
                if (option) {
                    option.dataset.rawPrice = price;
                    option.dataset.price = text;
                }
            });
        }

    });

    //CUSTOM SIZE
    let customSizeInput = sizesContainer.querySelector(`input[name="size"][value="custom-size"]`);
    if (customSizeInput && customSizeInput.dataset.width && customSizeInput.dataset.height) {
        let customSizeContainer = sizesContainer.querySelector('.custom-size');
        let width = customSizeInput.dataset.width;
        let height = customSizeInput.dataset.height;
        let pack = mainContainer.querySelector('input[name="option-pack"]');
        let color = mainContainer.querySelector('input[name="option-color"]');
        let supportColor = mainContainer.querySelector('input[name="option-supportColor"]');

        let responseCalculatePrice = await calculateCustomSizePrice(
            productId,
            width,
            height,
            pack ? pack.value : null,
            color ? color.value : null,
            supportColor ? supportColor.value : null
        );
        let price = responseCalculatePrice.price;

        price = formatPrice(price);
        customSizeContainer.querySelectorAll('.custom-price').forEach(function(priceContainer) {
            priceContainer.querySelector('.price, .value').innerHTML = price;
        });
    }
}

export async function goToConfiguration(currentConfiguration, configurationToGo)
{
    if (isDesktop()) {
        await fadeOut(currentConfiguration, 50);
        fadeIn(configurationToGo, 200, 'flex');
    } else {
        currentConfiguration.style.transition = 'none';
        currentConfiguration.classList.remove('offcanvas-bottom');
        currentConfiguration.classList.add('offcanvas-end');
        setTimeout(() => currentConfiguration.style.transition = '', 1);

        configurationToGo.style.transition = 'none';
        configurationToGo.classList.remove('offcanvas-bottom');
        configurationToGo.classList.add('offcanvas-end');
        setTimeout(() => configurationToGo.style.transition = '', 1);

        setTimeout(function() {
            hideOffcanvasByDomObject(currentConfiguration);
            showOffcanvasByDomObject(configurationToGo);
        }, 1);
    }

    currentConfiguration.classList.remove('open');
    configurationToGo.classList.add('open');
}

export async function addToCartMultiSize(mainContainer)
{
    showLoaderAddToCartButtons();

    let productId = mainContainer.dataset.productId;
    let productType = mainContainer.dataset.productType || '';
    let currentConfigurationOpened = isDesktop() ? mainContainer.closest('.product').querySelector('.product-configuration.open') : document.querySelector('#product-list-page .offcanvas.product-configuration.open');
    let options = getOptions(mainContainer);
    let complements = getComplements(mainContainer);
    let customizeSVG = mainContainer.querySelector('input[name="customizeSVG"]') ? mainContainer.querySelector('input[name="customizeSVG"]').value === 'true' : false;
    let products = [];

    options.sizes.forEach(function(size, index) {
        let finalOptions = {...options};
        delete finalOptions.sizes;
        finalOptions['width'] = size.width || '';
        finalOptions['height'] = size.height || '';
        finalOptions['device'] = size.device || '';
        finalOptions['composition'] = size.composition || '';

        let data = {
            productId: productId,
            quantity: size.quantity,
            options: finalOptions,
            isLocked: false
        }

        if (index === options.sizes.length - 1) data['extraProducts'] = complements;

        products.push(data);
    });

    if (customizeSVG && options['personalizedText'] && options['personalizedText'] !== '-') {
        let svgResponse = await getSvgPreviewImage(productId, options['personalizedText'], options['color']);

        products.forEach(function(product) {
            product['options']['personalizedSvg'] = convertSvgToBase64(svgResponse.svg);
            product['options']['personalizedImagePreview'] = svgResponse.svgPreview;
        });
    }

    let response = await addItems(products);
    let error = response.error;
    let message = response.message;
    let type = response.type;
    let items = response.items;

    hideLoaderAddToCartButtons();

    if (error) {
        let configuration = isDesktop() ? mainContainer.closest('.product').querySelector(`.product-configuration-${type}`) : document.querySelector(`#product-list-page .offcanvas.product-configuration-${type}`);
        let errorElement = configuration.querySelector('.error.general-error');

        errorElement.innerHTML = message;
        slideDown(errorElement);
        configuration.querySelector('.body').scrollTop = 0;
        trackProductPageGa4Events('AddToCartError', type);
    } else {
        if (isDesktop()) fadeOut(currentConfigurationOpened)
        else hideOffcanvasByDomObject(currentConfigurationOpened);
        openCart();
        updateItemsNumber(true);
        trackProductPageGa4Events('AddToCartQuickPurchase', productType);
        sendEventsAddToCart(items);
    }
}

export async function addToCart(mainContainer)
{
    showLoaderAddToCartButtons();

    let productId = mainContainer.dataset.productId;
    let productType = mainContainer.dataset.productType || '';
    let currentConfigurationOpened = isDesktop() ? mainContainer.closest('.product').querySelector('.product-configuration.open') : document.querySelector('#product-list-page .offcanvas.product-configuration.open');
    let options = getOptions(mainContainer);
    let complements = getComplements(mainContainer);
    let inputSizes = mainContainer.querySelector('input[name="option-size"]');
    let sizes = inputSizes && inputSizes.value !== '' ? JSON.parse(inputSizes.value) : [];
    let quantity = sizes.length === 1 ? parseInt(sizes[0].quantity) : 1;
    let customizeSVG = mainContainer.querySelector('input[name="customizeSVG"]') ? mainContainer.querySelector('input[name="customizeSVG"]').value === 'true' : false;

    if (customizeSVG && options['personalizedText'] && options['personalizedText'] !== '-') {
        let svgResponse = await getSvgPreviewImage(productId, options['personalizedText'], options['color']);
        options['personalizedSvg'] = convertSvgToBase64(svgResponse.svg);
        options['personalizedImagePreview'] = svgResponse.svgPreview;
        if (svgResponse.svgData) {
            options['generateSVGPersonalizedText'] = {
                'text': svgResponse.svgData.text,
                'svgFile': svgResponse.svgData.svgFile,
                'font': svgResponse.svgData.font,
                'color': svgResponse.svgData.color,
                'rightToLeft': svgResponse.svgData.rightToLeft
            };
        }
    }

    let data = {
        productId: mainContainer.dataset.productId,
        quantity: quantity,
        options: options,
        isLocked: false,
        extraProducts: complements
    }

    let response = await addItem(data);
    let error = response.error;
    let message = response.message;
    let type = response.type;
    let items = response.items;

    hideLoaderAddToCartButtons();

    if (error) {
        let configuration = isDesktop() ? mainContainer.closest('.product').querySelector(`.product-configuration-${type}`) : document.querySelector(`#product-list-page .offcanvas.product-configuration-${type}`);
        let errorElement = configuration.querySelector('.error.general-error');

        errorElement.innerHTML = message;
        slideDown(errorElement);
        configuration.querySelector('.body').scrollTop = 0;
        if (currentConfigurationOpened !== configuration) goToConfiguration(currentConfigurationOpened, configuration);
        trackProductPageGa4Events('AddToCartError', type);
    } else {
        if (isDesktop()) fadeOut(currentConfigurationOpened)
        else hideOffcanvasByDomObject(currentConfigurationOpened);
        openCart();
        updateItemsNumber(true);
        trackProductPageGa4Events('AddToCartQuickPurchase', productType);
        sendEventsAddToCart(items);
    }
}

function showLoaderAddToCartButtons()
{
    document.querySelectorAll('#product-list-page .product-configuration .btn-add-to-cart').forEach(function(button) {
        button.disabled = true;
        button.querySelector('.text').classList.add('d-none');
        button.querySelector('.loader').classList.remove('d-none');
    });
}

function hideLoaderAddToCartButtons()
{
    document.querySelectorAll('#product-list-page .product-configuration .btn-add-to-cart').forEach(function(button) {
        button.disabled = false;
        button.querySelector('.loader').classList.add('d-none');
        button.querySelector('.text').classList.remove('d-none');
    });
}

export function addComplement(complementInput)
{
    let configurationMain = isDesktop() ? complementInput.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let complementsInput = configurationMain.querySelector('input[name="complements"]')
    let complements = complementsInput.value !== '' ? JSON.parse(complementsInput.value) : [];

    if (!(complements.some(complement => complement.id === complementInput.value))){
        complements.push(
            {
                'id': complementInput.value,
                'width': complementInput.dataset.width,
                'height': complementInput.dataset.height,
                'device': complementInput.dataset.device,
                'composition': complementInput.dataset.composition,
                'price': complementInput.dataset.price,
                'quantity': 1,
                'isLocked': complementInput.dataset.locked === 'true',
                'linkToParent': complementInput.dataset.linkToParent === 'true'
            }
        );
    }

    complementsInput.value = JSON.stringify(complements);
}

export function removeComplement(complementInput)
{
    let configurationMain = isDesktop() ? complementInput.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let complementsInput = configurationMain.querySelector('input[name="complements"]')
    let complements = complementsInput.value !== '' ? JSON.parse(complementsInput.value) : [];
    let index = complements.findIndex(complement => complement.id === complementInput.value);

    if (index !== -1) complements.splice(index, 1);

    complementsInput.value = JSON.stringify(complements);
}

export function updateOpenConfigurationButtons()
{
    if (isPremiumUser()) {
        document.querySelectorAll('#product-list-page .exclusive-premium-product').forEach(function(product) {
            let button = product.querySelector('.btn-configure-product');
            if (!button) return;
            showElement(button);
        });
    }
}